/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Type/category of competitive event
 * @export
 */
export const TournamentCategory = {
    TOURNAMENT: 'TOURNAMENT',
    MONEY_MATCH: 'MONEY_MATCH',
    LEAGUE: 'LEAGUE',
    SCRIMMAGE: 'SCRIMMAGE',
    QUALIFIER: 'QUALIFIER'
} as const;
export type TournamentCategory = typeof TournamentCategory[keyof typeof TournamentCategory];


export function instanceOfTournamentCategory(value: any): boolean {
    for (const key in TournamentCategory) {
        if (Object.prototype.hasOwnProperty.call(TournamentCategory, key)) {
            if (TournamentCategory[key as keyof typeof TournamentCategory] === value) {
                return true;
            }
        }
    }
    return false;
}

export function TournamentCategoryFromJSON(json: any): TournamentCategory {
    return TournamentCategoryFromJSONTyped(json, false);
}

export function TournamentCategoryFromJSONTyped(json: any, ignoreDiscriminator: boolean): TournamentCategory {
    return json as TournamentCategory;
}

export function TournamentCategoryToJSON(value?: TournamentCategory | null): any {
    return value as any;
}

export function TournamentCategoryToJSONTyped(value: any, ignoreDiscriminator: boolean): TournamentCategory {
    return value as TournamentCategory;
}

